import BeddingSectionButton from './BeddingSectionButton';

export default BeddingSectionButton;
